import { useContext } from "react";
import { Context } from "Context";

const Icon = ({
	icon = null,
	className = "",
	title = "",
	rotate = false,
	loading = "lazy",
}) => {
	const { config } = useContext(Context);
	const mainClass = `help-icon ${className}${
		icon ? ` help-icon--${icon}` : ""
	}${rotate ? " help-icon--rotate" : ""}`;

	const iconUrl = `${config.cdnAssetsUrl}/icons/pep/${icon}.svg`;

	if (!icon) {
		return null;
	}

	return (
		<img
			alt={title}
			title={title}
			className={mainClass}
			src={iconUrl}
			loading={loading}
		/>
	);
};

export default Icon;
